// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__Izh04"};